"use client";

import React from "react";

const inputClass =
  "w-full rounded-lg border border-gray-300 px-4 py-3 text-sm focus:border-mygreen focus:ring-2 focus:ring-mygreen/10 transition-all";

const inputErrorClass =
  "w-full rounded-lg border border-red-300 px-4 py-3 text-sm focus:border-red-500 focus:ring-2 focus:ring-red-100 transition-all";

type FormInputProps = {
  id: string;
  name: string;
  label: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  error?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  maxLength?: number;
  className?: string;
  disabled?: boolean;
};

/**
 * Componente de input de formulário reutilizável
 */
export const FormInput: React.FC<FormInputProps> = ({
  id,
  name,
  label,
  type = "text",
  placeholder,
  required = false,
  error,
  value,
  onChange,
  onBlur,
  maxLength,
  className,
  disabled = false,
}) => {
  return (
    <div className="space-y-2">
      <label htmlFor={id} className="text-sm font-semibold text-gray-700">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <input
        id={id}
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        maxLength={maxLength}
        className={className || (error ? inputErrorClass : inputClass)}
        disabled={disabled}
        required={required}
      />
      {error && <p className="text-xs text-red-600">{error}</p>}
    </div>
  );
};

type FormTextareaProps = {
  id: string;
  name: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  error?: string;
  rows?: number;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

/**
 * Componente de textarea de formulário reutilizável
 */
export const FormTextarea: React.FC<FormTextareaProps> = ({
  id,
  name,
  label,
  placeholder,
  required = false,
  error,
  rows = 3,
  value,
  onChange,
}) => {
  return (
    <div className="space-y-2">
      <label htmlFor={id} className="text-sm font-semibold text-gray-700">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <textarea
        id={id}
        name={name}
        rows={rows}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={error ? inputErrorClass : inputClass}
        required={required}
      />
      {error && <p className="text-xs text-red-600">{error}</p>}
    </div>
  );
};
